import React from "react"
import styled from "styled-components"
import shareImg from "../images/share-character.png"
import { share } from "../common/utils"
import { logUserEvent } from "../common/firebase.utils"

export default function Share() {
  const onClickShare = () => {
    share()
    logUserEvent("share", { location: "main" })
  }

  return (
    <Section>
      <Content>
        <CharacterImg src={shareImg} alt="share character" />
        <TextArea>
          <Title>
            주변에 <strong>공유</strong>해주세요
          </Title>
          <DescButtonGroup>
            <Description>
              말이 막막한 순간, 필요한 문구를 쉽게 찾을 수 있도록 주변에
              알려주세요.
            </Description>
            <ShareButton onClick={onClickShare}>
              주변에 사이트 공유할래요
            </ShareButton>
          </DescButtonGroup>
        </TextArea>
      </Content>
    </Section>
  )
}

const Section = styled.div`
  padding: 40px 20px 64px;
  text-align: center;
  background: #fff;

  @media (max-width: 800px) {
    padding: 28px 20px 44px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 640px;
  margin: 0 auto;
`

const CharacterImg = styled.img`
  width: 180px;
  height: auto;
  flex-shrink: 0;

  @media (max-width: 800px) {
    width: 140px;
  }
`

const TextArea = styled.div`
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
`

const DescButtonGroup = styled.div`
  width: max-content;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 800px) {
    width: 100%;
  }
`

const Title = styled.h2`
  display: none;
  font-size: 28px;
  font-weight: 400;
  color: #0f0e2c;
  line-height: 140%;
  margin-top: 16px;
  margin-bottom: 0;

  strong {
    font-weight: 700;
  }
`

const Description = styled.p`
  display: none;
  font-size: 14px;
  color: #6b7280;
  line-height: 170%;
  word-break: keep-all;
  margin-top: 6px;
  margin-bottom: 0;
`

const ShareButton = styled.button`
  width: 100%;
  margin-top: 18px;
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  border: 1px solid #0f0e2c;
  border-radius: 12px;
  background: #0f0e2c;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1a1940;
    border-color: #1a1940;
    transform: translateY(-1px);
  }

  @media (max-width: 800px) {
    padding: 16px;
  }
`
